import Vue from 'vue';

export default Vue.extend({
  name: 'jquery-mixin',
  methods: {
    jquery: function () {
      // @ts-ignore
      return window.jQuery || window.jquery || window.$;
    }
  }
});
